'use client';

import { Loader2 } from 'lucide-react';

export interface LoadingScreenProps {
  // Add any props if needed in the future
}

export function LoadingScreen(props: LoadingScreenProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-background text-foreground">
      <div className="mb-6">
        <a href="/">
          <img
            src={window.location.origin + '/logo_only.webp'}
            alt="CitySage Logo"
            className="h-9 w-auto block md:hidden"
          />
          <img
            src={window.location.origin + '/logo_text_horizontal.webp'}
            alt="CitySage Logo"
            className="h-9 w-auto hidden md:block"
          />
        </a>
      </div>
      <h1 className="text-4xl font-bold mb-4 text-center">
        CitySage
      </h1>
      <div className="flex items-center space-x-3 mt-12 mb-4">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
        <span className="text-lg">Loading, please wait...</span>
      </div>
    </div>
  );
}
